import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddProfile = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.45703 12.2227C10.2983 12.2227 12.6005 14.4388 12.6006 17.1748C12.6006 17.6302 12.217 17.9998 11.7441 18H1.45703C0.984043 17.9999 0.600586 17.6303 0.600586 17.1748C0.600696 14.4388 2.90286 12.2227 5.74414 12.2227H7.45703ZM14.5 6.90039C14.8063 6.90039 15.0537 7.14776 15.0537 7.4541V9.94629H17.5459C17.8522 9.94629 18.0996 10.1937 18.0996 10.5C18.0996 10.8063 17.8522 11.0537 17.5459 11.0537H15.0537V13.5459C15.0537 13.8522 14.8063 14.0996 14.5 14.0996C14.1937 14.0996 13.9463 13.8522 13.9463 13.5459V11.0537H11.4541C11.1478 11.0537 10.9004 10.8063 10.9004 10.5C10.9004 10.1937 11.1478 9.94629 11.4541 9.94629H13.9463V7.4541C13.9463 7.14776 14.1937 6.90039 14.5 6.90039ZM6.60059 4C8.51293 4.00005 10.0623 5.49152 10.0625 7.33301C10.0625 9.17465 8.51304 10.6669 6.60059 10.667C4.68809 10.667 3.13867 9.17467 3.13867 7.33301C3.13885 5.49149 4.6882 4 6.60059 4Z",
		fill: "#0D2976"
	})
});
export default SvgAddProfile;
